/**
 * Admin Studio v1 — AdminCreateSheet
 * Bottom sheet wrapper for mobile create forms.
 * Provides consistent header, scrollable body, and sticky footer.
 */
import type { ReactNode } from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
} from '@/components/ui/sheet';

interface AdminCreateSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
  footerActions: ReactNode;
}

export function AdminCreateSheet({
  open,
  onOpenChange,
  title,
  children,
  footerActions,
}: AdminCreateSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="rounded-t-2xl max-h-[85dvh] flex flex-col">
        <SheetHeader className="text-left pb-2">
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto py-2 px-1">
          {children}
        </div>
        <SheetFooter
          className="flex-row gap-2 pt-3"
          style={{ paddingBottom: 'calc(8px + env(safe-area-inset-bottom, 0px))' }}
        >
          {footerActions}
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
